var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-box"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("@/static/images/home-banner-4-box.png")}})]),_vm._v(" "),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/home/carousel/line-animate.vue?vue&type=template&id=4a3af991&scoped=true
// module id = null
// module chunks = 